
import {datos_pacientes, asign_datos_pacientes} from './datos/datos_pacientes.js';
import {datos_proveedores_lente, asign_datos_proveedores_lente} from './datos/datos_proveedores_lente.js';
import {datos_proveedores_montura, asign_datos_proveedores_montura} from './datos/datos_proveedores_montura.js';
import {info_agendas, asign_info_agendas} from './info/info_agendas.js';
import {info_examens, asign_info_examens} from './info/info_examens.js';
import {info_ventas, asign_info_ventas} from './info/info_ventas.js';
import {info_orden, asign_info_orden} from './info/info_orden.js';
import {info_garantia, asign_info_garantia} from './info/info_garantia.js';
import {examen_antecedentes, asign_examen_antecedentes} from './examen_antecedentes.js';
import {examen_pruebas, asign_examen_pruebas} from './examen_pruebas.js';
import {examen_diagnosticos, asign_examen_diagnosticos} from './examen_diagnosticos.js';
import {garantia_antecedentes, asign_garantia_antecedentes} from './garantia_antecedentes.js';
import {garantia_pruebas, asign_garantia_pruebas} from './garantia_pruebas.js';
import {garantia_diagnosticos, asign_garantia_diagnosticos} from './garantia_diagnosticos.js';
import {garantia_orden, asign_garantia_orden} from './garantia_orden.js';
import {users, asign_users} from './users.js';

export const asign_data = () => 
{
        var permisos_modulos= {}
        var asign_dataForm = {} 
        var asign_dataPost = {} 
        var asign_dataGet = {} 
        var asign_datadb = {
                datos_pacientes: datos_pacientes().datos_pacientes,
                datos_proveedores_lente: datos_proveedores_lente().datos_proveedores_lente,
                datos_proveedores_montura: datos_proveedores_montura().datos_proveedores_montura,
                info_agendas: info_agendas().info_agendas,
                info_ventas: info_ventas().info_ventas,
                info_orden: info_orden().info_orden,
                info_garantia: info_garantia().info_garantia,
                examen_antecedentes: examen_antecedentes().examen_antecedentes,
                examen_pruebas: examen_pruebas().examen_pruebas,
                examen_diagnosticos: examen_diagnosticos().examen_diagnosticos,
                garantia_antecedentes: garantia_antecedentes().garantia_antecedentes,
                garantia_pruebas: garantia_pruebas().garantia_pruebas,
                garantia_diagnosticos: garantia_diagnosticos().garantia_diagnosticos,
                garantia_orden: garantia_orden().garantia_orden,
                users: users().users,
        }

        var dataForm_routes = {}
        var dataForm_object = {}    

        dataForm_routes = Object.assign(dataForm_routes, asign_users(), asign_datos_pacientes(), asign_info_garantia(), asign_info_ventas(), asign_info_agendas(), asign_info_orden(), asign_info_examens(), asign_examen_antecedentes(), asign_examen_pruebas(), asign_examen_diagnosticos(), asign_garantia_antecedentes(), asign_garantia_pruebas(), asign_garantia_diagnosticos(), asign_datos_proveedores_lente(), asign_datos_proveedores_montura(), asign_garantia_orden())
            
        dataForm_object = Object.assign(dataForm_object,users(),datos_pacientes(),info_ventas(),info_agendas(),info_garantia(),info_examens(),examen_antecedentes(),examen_pruebas(),examen_diagnosticos(),garantia_antecedentes(),garantia_pruebas(),garantia_diagnosticos(),info_orden(),garantia_orden(),datos_proveedores_montura(),datos_proveedores_lente())
         
        var routes= Object.keys(dataForm_routes);
        var tablas= Object.keys(dataForm_object);

        for(var m=0;m<routes.length;m++)
        {           
            let splitModulos = routes[m].split('_')

           if(permisos_modulos[splitModulos[0]]===undefined)
           {
                permisos_modulos[splitModulos[0]]={}
           }

           permisos_modulos[splitModulos[0]][splitModulos[1]]=false  
        
            asign_dataPost [routes[m]] = {
                data: [],
                route: '',
                tablaPost: [],
                tablaAuditar: false
            }       
            asign_dataGet [routes[m]] = {
                data: [],
            } 
            for(var i=0; i<tablas.length; i++)
            {      
                    var campos= Object.keys(dataForm_object[tablas[i]]);  
                    for(var j=0;j<campos.length;j++)
                    {
                            var createdataform= dataForm_object[tablas[i]][campos[j]].dataform
                            for(var k=0; k<createdataform.length;  k++)
                            {             
                                    if(createdataform[k]===routes[m]) 
                                    {     
                                        if(asign_dataForm [routes[m]] === undefined)
                                        {
                                                asign_dataForm [routes[m]] = {}
                                        } 
                                        if(tablas[i].includes('multiple_'))
                                        {                                                
                                                if(asign_dataForm [routes[m]] [tablas[i].substring(9)+'_nuevos'] === undefined)
                                                {
                                                        asign_dataForm [routes[m]] [tablas[i].substring(9)+'_nuevos'] = []  
                                                        asign_dataForm [routes[m]] [tablas[i].substring(9)+'_activos'] = []  
                                                        asign_dataForm [routes[m]] [tablas[i].substring(9)+'_inits'] = []  
                                                }                        
                                        }
                                        else{   
                                                if(asign_dataForm [routes[m]] [tablas[i]] === undefined)
                                                {
                                                        asign_dataForm [routes[m]] [tablas[i]] = {}
                                                }                                            
                                                asign_dataForm [createdataform[k]] [tablas[i]] [campos[j]] = dataForm_object[tablas[i]][campos[j]].datatype.predeterminate
                                        }                                                        
                                    }                                                  
                            }
                    }             
            } 
        }    
        return { dataForm: asign_dataForm, dataPost: asign_dataPost, datadb: asign_datadb, dataGet: asign_dataGet, permisos_modulos:  permisos_modulos}
}
